import request from '@/utils/request'

/** 人事填报表单选项（来源门店、员工、目标门店） */
export function getPersonnelReportFormOptions(data = {}) {
  return request({
    url: '/api/Extend/LqPersonnelReport/FormOptions',
    method: 'get',
    data
  })
}

/** 提交人事填报（调动 / 离职） */
export function submitPersonnelReport(data) {
  return request({
    url: '/api/Extend/LqPersonnelReport/Submit',
    method: 'post',
    data
  })
}
